import { render } from "./EmailSms.vue?vue&type=template&id=28982fef&lang=true"
import script from "./EmailSms.vue?vue&type=script&lang=js"
export * from "./EmailSms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__